<div class="wallet-qris-detail-container">
    <div class="detail-box">
        <div class="label-value-content">
            <span><strong>{{ 'wallet_qris.limit_available' | translate}}</strong></span>
            <span><strong>{{ token_data?.available_balance | paperCurrency }}</strong></span>
        </div>
    </div>
    <div class="detail-box">
        <div class="box-head">
            <div class="box-title">{{ 'wallet_qris.payment_information' | translate}}</div>
        </div>
        <div class="label-value-content">
            <span class="text-gray">{{ 'wallet_qris.trx_id' | translate}}</span>
            <span>{{data.reference_no}}</span>
        </div>
        <div class="label-value-content">
            <span class="text-gray">Merchant</span>
            <span><strong>{{data.merchant_name}}</strong></span>
        </div>
        <div class="label-value-content">
            <span><strong>{{ 'wallet_qris.trx_total' | translate}}</strong></span>
        </div>
        <p-inputnumber
            #inputNumRef 
            [(ngModel)]="paymentAmount" 
            placeholder="cth. Rp1.000.000"
            [min]="0"
            class="paper-input paper-input-number"
            inputId="currency-id" 
            mode="currency" 
            [currency]="currency"
            minFractionDigits = "0"
            maxFractionDigits = "0" 
            locale="id"
            [disabled]="isAmountDisabled"
            (onKeyPress)="preventInvalidChars($event)"
            (onInput)="onInput($event)"
            (input)="sanitize($event)"
        />
        <span 
            *ngIf="!paymentAmount || isTransactionValid" 
            class=" text-gray text-small"
        >
            {{ 'wallet_qris.trx_hint' | translate}}
        </span>
        <span 
            *ngIf="paymentAmount && !isTransactionValid" 
            class="text-red text-small"
        >
            {{ 'wallet_qris.trx_invalid' | translate}}
        </span>

    </div>
    <div class="detail-box">
        <div class="box-head">
            <div class="box-title">{{ 'wallet_qris.lbl_budget_title' | translate}}</div>
            <div class="box-subtitle text-gray">{{ 'wallet_qris.lbl_budget_desc' | translate}}</div>
        </div>
        <p-select 
            [options]="categories" 
            [(ngModel)]="budgetCategory" 
            optionLabel="name" 
            placeholder="Pilih Kategori"
            class="w-full md:w-56 paper-input paper-input-select" />
    </div>
    <div class="certificate-container">
        <img src="./assets/images/wallet-trust-certificate.svg" alt="Wallet Trust Certificate"/> 
    </div>
    <div class="sticky-button-container">
        <button 
            type="button" 
            class="paper-button blue-button w-100" 
            [ngClass]="{'disabled': !isTransactionValid || isFieldFocused}"
            [disabled]="!isTransactionValid || isFieldFocused"
            (click)="continueTransaction()"
        >
            Lanjutkan
        </button>
    </div>
</div>